function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 15)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 39.13,
  cy: 24.968,
  r: 22.22,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#17BED0",
  d: "M42.884 32.77h-8.261v6.544c0 1.9-1.324 3.253-3.183 3.253-1.86 0-3.183-1.352-3.183-3.253V14.82c0-1.901 1.323-3.254 3.183-3.254h11.444c5.58 0 10.372 4.606 10.372 10.602.036 5.995-4.506 10.601-10.372 10.601zm.16-14.203h-8.787v7h8.787c1.858-.234 3.18-1.741 3.18-3.483.285-2.01-1.322-3.249-3.18-3.517zm24.013 15.067c2.96-1.955 3.38-4.94 3.38-8.666 0-5.31-1.213-10.013-6.312-10.806 1.374 2.748.211 4.73 0 7.477C62.539 9.46 52.129 0 39.34 0c-13.765 0-23.99 11.493-23.99 25.259 0 2.351-.581 4.227 0 6.394-1.19-2.748-1.77-5.892-1.77-9.036 0-2.96.58-5.892 1.585-8.455C6.5 15.35 0 23.013 0 32.049c0 9.829 7.874 18.099 17.702 18.469h48.563c6.684-.185 12.391-6.104 12.391-12.788-.026-4.703-2.377-8.614-6.103-10.78-.581 3.54-2.748 5.495-5.496 6.684z"
}));

var SvgPcloudIco = function SvgPcloudIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPcloudIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pcloud_ico.0e52de2e.svg";
export { ForwardRef as ReactComponent };